import { useEffect } from 'react';

import { JOKI } from '../../JOKI';

export function useRedirectToMap(props) {
    useEffect(() => {
        return JOKI.on({
            key: 'moveMapToCoords',
            fn: event => {
                if (props.location.pathname !== '/map') {
                    props.history.push('/map');
                    // This is a really hacky way to do this
                    // but this is the restriction of the React Router
                    setTimeout(() => {
                        JOKI.trigger(event);
                    }, 2000);
                }
            },
        });
        // eslint-disable-next-line
    }, [props.location]);
}
